// extracted by mini-css-extract-plugin
export default {"inputSelect":"Farmer_inputSelect__rNQLX"};